import { createAsyncThunk } from '@reduxjs/toolkit';

import { vitrinsQueries } from 'entities/vitrins/model/vitrins.query';
import type { TFilterAlias, TVitrinsFiltersState } from 'entities/vitrinsFilters';
import { selectActiveCreditCardsVitrinsFilters, toggleFilter } from 'entities/vitrinsFilters';

export const applyCreditCardsFilterThunk = createAsyncThunk<
  void,
  { alias: TFilterAlias; value: string | number; callback?: () => void },
  { state: TVitrinsFiltersState }
>('vitrinsCreditCardsFilters/apply', async ({ alias, value, callback }, { dispatch, getState }) => {
  dispatch(toggleFilter({ alias, value }));

  const state = getState();

  const filtersMap = selectActiveCreditCardsVitrinsFilters(state);

  await dispatch(
    vitrinsQueries.endpoints.getVitrins.initiate(
      { productName: 'credit-cards', ...filtersMap },
      { forceRefetch: true },
    ),
  );
  callback?.();
});
